import React from 'react';

// Components
import WpAvatarGroup from '../WpAvatarGroup';

const AvatarGroupDocs = () => {
  const users = [
    {
      id: 103154,
      email: 'josh@9.org',
      fullName: 'joshs 9',
      firstName: 'joshs',
      lastName: '9',
      avatar: {
        color: '#F5C20D',
        initials: 'J9',
        profilePictureUrl:
          'http://localhost:5000/rails/active_storage/representations/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBazAzIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--97d1bb9b819246fd210f22193eea43a422b4f996/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCam9VWTI5dFltbHVaVjl2Y0hScGIyNXpldzA2QzNKbGMybDZaVWtpRFRJMU5uZ3lOVFplQmpvR1JWUTZER2R5WVhacGRIbEpJZ3RqWlc1MFpYSUdPd2RVT2d0bGVIUmxiblJKSWd3eU5UWjRNalUyQmpzSFZEb0tjM1J5YVhCVU9oUnpZVzF3YkdsdVp5MW1ZV04wYjNKSklnbzBPakk2TUFZN0IxUTZESEYxWVd4cGRIbEpJZ2M0TlFZN0IxUTZEbWx1ZEdWeWJHRmpaVWtpQ1VwUVJVY0dPd2RVT2c5amIyeHZjbk53WVdObFNTSUpjMUpIUWdZN0IxUT0iLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--9b7e7e705270d9e568ade03820f3b541acbe5ba9/mike.jpg',
        label: 'joshs 9',
      },
      confirmationSentAt: '2020-11-04T12:36:28.919-08:00',
      confirmedAt: '2020-11-04T12:36:52.137-08:00',
      zoomData: {},
      pulseMood: 'MEH_ROLLING_EYES',
      displayName: 'joshs 9',
      personId: 956624,
      personIdentifier: 'josh@9.org',
      label: 'joshs 9',
      hasSlackNotifications: null,
      role: 'manager',
      organizationRole: 'admin',
    },
    {
      id: 103155,
      email: 'billy@9.org',
      fullName: 'Billy S',
      firstName: 'Billy',
      lastName: 'S',
      avatar: {
        color: '#D41C8A',
        initials: 'BS',
        profilePictureUrl: null,
        label: 'Billy S',
      },
      confirmationSentAt: '2020-11-04T12:37:38.580-08:00',
      confirmedAt: '2020-11-04T12:38:10.634-08:00',
      zoomData: {},
      pulseMood: null,
      displayName: 'Billy S',
      personId: 956625,
      personIdentifier: 'billy@9.org',
      label: 'Billy S',
      hasSlackNotifications: null,
      role: 'full_member',
      organizationRole: 'admin',
    },
    {
      avatar: { color: '#5C6ECB', initials: 'DM', profilePictureUrl: null, label: 'dj matthew' },
      confirmationSentAt: '2020-11-04T12:50:30.110-08:00',
      confirmedAt: '2020-11-04T12:51:04.663-08:00',
      displayName: 'dj m',
      email: 'dj@9.org',
      firstName: 'dj',
      fullName: 'dj matthew',
      hasSlackNotifications: null,
      id: 103156,
      label: 'dj matthew',
      lastName: 'matthew',
      organizationRole: 'admin',
      personId: 956626,
      personIdentifier: 'dj@9.org',
      pulseMood: null,
      role: 'full_member',
      type: 'user',
      zoomData: {},
    },
    {
      avatar: { color: '#D41C8A', initials: 'JJ', profilePictureUrl: null, label: 'Joel Johnson' },
      confirmationSentAt: '2020-11-09T10:50:15.181-08:00',
      confirmedAt: '2020-12-07T09:10:14.547-08:00',
      displayName: 'Joel J',
      email: 'joel@9.org',
      firstName: 'Joel',
      fullName: 'Joel Johnson',
      hasSlackNotifications: null,
      id: 103157,
      label: 'Joel Johnson',
      lastName: 'Johnson',
      organizationRole: 'regular_user',
      personId: 956627,
      personIdentifier: 'joel@9.org',
      pulseMood: null,
      role: 'full_member',
      type: 'user',
      zoomData: {},
    },
    {
      avatar: { color: '#B7D210', initials: 'VH', profilePictureUrl: null, label: 'Victor Hugo' },
      confirmationSentAt: '2020-11-18T17:04:45.494-08:00',
      confirmedAt: '2020-12-02T20:43:37.833-08:00',
      displayName: 'Victor H',
      email: 'victor@9.org',
      firstName: 'Victor',
      fullName: 'Victor Hugo',
      hasSlackNotifications: null,
      id: 103165,
      label: 'Victor Hugo',
      lastName: 'Hugo',
      organizationRole: 'regular_user',
      personId: 956635,
      personIdentifier: 'victor@9.org',
      pulseMood: null,
      role: 'full_member',
      type: 'user',
      zoomData: {},
    },
  ];

  return (
    <>
      <div className="d-flex flex-column">
        <WpAvatarGroup users={users} size="sm" limit={3} showAdditionalCount />
        <WpAvatarGroup users={users} size="md" stacked showAdditionalCount />
        <WpAvatarGroup users={users} size="lg" stacked={true} showAdditionalCount />
        <WpAvatarGroup users={users} size="xl" stacked={true} showAdditionalCount />
        <WpAvatarGroup users={users} size="xxl" stacked={true} showAdditionalCount />
        <WpAvatarGroup users={users} size="xxxl" stacked={true} showAdditionalCount />
      </div>
    </>
  );
};

export default AvatarGroupDocs;
